module.exports = __webpack_public_path__ + "static/media/chevron-up.54d9aa76.svg";